/**
 * @ngdoc directive
 * @name fileSelectionChange
 * @restrict A
 * @description
 * Detect the change event on HTML file fields.
 *
 * Example:
 * <input
 *     type="file" accept="image/*"
 *     "callbackFunction(files)"
 * />
 *
 * @memberof common
 * @return {Object} The directive properties.
 */
const FileSelectionChange = () => ({
  restrict: 'A',
  scope: {
    fileSelectionChange: '&',
  },
  link($scope, $element) {
    const element = $element[0];
    const onSelectionChange = ({ target: { files } }) => {
      if (files.length > 0) {
        $scope.fileSelectionChange({ files });
        // Clear element
        element.value = '';
      }
    };

    element.addEventListener('change', onSelectionChange);

    $scope.$on('$destroy', () => {
      element.removeEventListener('change', onSelectionChange);
    });
  },
});

export default FileSelectionChange;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/directives/fileSelectionChange.js